import { AppBar, Button, Container, Toolbar } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/typica-logo-white.png';
import FooterContainer from '../FooterContainer';
var CookiePolicyPage = function () {
    React.useLayoutEffect(function () {
        // ot-sdk-cookie-policy, ot-sdk-show-settingsがうまく動かないことがあるのでdomが描画されてから
        // scriptをloadしなおす
        var scriptElement = document.querySelector("script[src=\"".concat(TYPICA_ONE_TRUST_SDK_STUB_SCRIPT_URL, "\"]"));
        if (scriptElement) {
            scriptElement.remove();
        }
        var headTag = document.getElementsByTagName('head')[0];
        var scriptTag = document.createElement('script');
        scriptTag.type = 'text/javascript';
        scriptTag.src = TYPICA_ONE_TRUST_SDK_STUB_SCRIPT_URL;
        scriptTag.dataset.domainScript =
            TYPICA_ONE_TRUST_SDK_STUB_DATA_DOMAIN_SCRIPT;
        headTag.appendChild(scriptTag);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(AppBar, { position: "static" },
            React.createElement(Toolbar, null,
                React.createElement("div", { className: "brand" },
                    React.createElement(Button, { color: "inherit", component: Link, to: "/" },
                        React.createElement("img", { src: logo, height: "30" }))))),
        React.createElement(Container, { sx: { marginY: 3 } },
            React.createElement("div", { id: "ot-sdk-cookie-policy" }),
            React.createElement("button", { id: "ot-sdk-btn", className: "ot-sdk-show-settings" })),
        React.createElement(FooterContainer, null)));
};
export default CookiePolicyPage;
